// Create and open the modal

function floowOpenModal(content) {
  const modal = document.querySelector(".floow-modal");

  if (!modal) {
    // If theres no modal container, create one and put it at the beginning of the body
    const modalText = `
      <div class="floow-modal">
        <div class="floow-modal-background" onclick="floowCloseModal();"></div>
        <div class="floow-modal-content-container">
          <svg 
            class="floow-modal-close"
            onclick="floowCloseModal()"
            role="presentation" stroke-width="2" focusable="false" width="24" height="24" viewBox="0 0 24 24">
              <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343"></path>
          </svg>
          <div class="floow-modal-content"></div>
        </div>
      </div>  
      `;
    const modalHTML = new DOMParser().parseFromString(modalText, "text/html");
    const modalElement = modalHTML.body.querySelector(".floow-modal");
    document.body.prepend(modalElement);
  }

  // Put the content in the modal
  const modalContent = document.querySelector(".floow-modal-content");
  modalContent.innerHTML = content.innerHTML;

  // Open the modal
  document.querySelector(".floow-modal").setAttribute("open", "");
}

// Close the modal

function floowCloseModal() {
  document.querySelector(".floow-modal").removeAttribute("open");
}

// Money formatting

function floowFormatMoney(cents) {
  if (!cents) return '';
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  }).format(cents / 100);
}

// Initialize slider

function floowInitializeSlider(settings, id) {
  const sliderId = id;
  const slider = document.querySelector(`.slider-${sliderId}`);
  const leftArrow = document.querySelector(`.left-arrow-${sliderId}`);
  const rightArrow = document.querySelector(`.right-arrow-${sliderId}`);
  const slides = Array.from(slider.children);
  let activeSlide = 0;

  slides.forEach((slide, i) => {
    slide.setAttribute("data-index", i) 
  })

  floowCalculateSlideWidth(slider, slides, settings);
  window.addEventListener("resize", () => {
    floowCalculateSlideWidth(slider, slides, settings);
  });



  // Left arrow
  leftArrow.addEventListener("click", () => {
     if (activeSlide > 0) {
       activeSlide -= 1;
     }
    
     document.querySelector(`.block-${id}[data-index="${activeSlide}"]`).scrollIntoView({ inline: "start", behavior: 'smooth' });
  });

  // Right arrow
  rightArrow.addEventListener("click", () => {
     if (activeSlide < slides.length - settings.slidesPerView) {
       activeSlide += 1;
     }
    document.querySelector(`.block-${id}[data-index="${activeSlide}"]`).scrollIntoView({ inline: "start", behavior: 'smooth' });
  });
}

// Calculate slide width depending on viewport
function floowCalculateSlideWidth(slider, slides, settings) {
  let sliderWidth = slider.offsetWidth;
  let slideWidth;

  if (window.innerWidth > settings.mobile.width) {
    slideWidth = (sliderWidth - settings.gap * (settings.slidesPerView - 1)) / settings.slidesPerView;
  } else {
    slideWidth = (sliderWidth - settings.mobile.gap * (settings.mobile.slidesPerView - 1)) / settings.mobile.slidesPerView;
  }

  slides.forEach((slide) => {
    slide.style.width = `${slideWidth}px`;
  });
}


// Variant select
async function floowChangeVariant(productHandle, productId, sectionId, event) { 
  const container = event.target.closest(`.floow-variant-picker-wrapper[product-id="${productId}"]`);
  const variantIds = [];
  
container.querySelectorAll(`.floow-variant-picker-wrapper[product-id="${productId}"] .floow-variant-picker-value:checked`).forEach((value) => {
  variantIds.push(value.getAttribute("value-id"));
  console.log(value)
});


  const url = `${window.location.origin}/products/${productHandle}?section_id=${sectionId}&option_values=${variantIds.join(',')}`;
  const response = await fetch(url);
  const htmlString = await response.text();
  const html = new DOMParser().parseFromString(htmlString, "text/html");

  // Replace Code
  container.innerHTML = html.querySelector(`.floow-variant-picker-wrapper[product-id="${productId}"]`).innerHTML;
}
